'use client';

import { Chip } from '@common/components';
import useEmblaCarousel from 'embla-carousel-react';

import { POLICY_CASE_BABY_CHILD_COUNT } from '@/api';

interface ChildCountSwiperProps {
  childCount: POLICY_CASE_BABY_CHILD_COUNT;
  subRegionCode: string;
  onChangeChildCount?: (childCount: POLICY_CASE_BABY_CHILD_COUNT) => void;
}

export const ChildCountSwiper = ({
  childCount,
  onChangeChildCount,
}: ChildCountSwiperProps) => {
  const [emblaRef] = useEmblaCarousel({
    align: 'start',
    dragFree: true,
    containScroll: 'trimSnaps',
  });

  return (
    <div
      className="scrollbar-hide w-full overflow-x-scroll py-8 pl-20"
      ref={emblaRef}
    >
      <div className="flex gap-6">
        {CHILD_COUNT_LIST.map(({ key, label }) => (
          <div key={key} className="w-fit flex-[0_0_auto] last:mr-20">
            <Chip
              checked={key === childCount}
              className="flex h-34 select-none items-center typo-body4"
              theme="primary"
              onClick={() => onChangeChildCount?.(key)}
            >
              {label}
            </Chip>
          </div>
        ))}
      </div>
    </div>
  );
};

const CHILD_COUNT_LIST = [
  {
    key: POLICY_CASE_BABY_CHILD_COUNT.FIRST,
    label: '첫째아이',
  },
  {
    key: POLICY_CASE_BABY_CHILD_COUNT.SECOND,
    label: '둘째아이',
  },
  {
    key: POLICY_CASE_BABY_CHILD_COUNT.THIRD,
    label: '셋째아이',
  },
  {
    key: POLICY_CASE_BABY_CHILD_COUNT.FOURTH,
    label: '넷째아이',
  },
  {
    key: POLICY_CASE_BABY_CHILD_COUNT.FIFTH,
    label: '다섯째아이',
  },
];
